import React, {useEffect, useState} from "react";
import Tr from "translations/Translations";
import PapersGeneratorService from "services/PapersGeneratorService";
import PapersGeneratorSelectPopup from "./PapersGeneratorSelectPopup";
import PropTypes from "prop-types";

const PapersGeneratorRfxInvitedSupplierPosition = (
    {
        demandId,
        paper,
        onClose,
        shareSystem
    }) => {

    const [invitedSuppliers, setInvitedSuppliers] = useState(null);
    const [chosenSupplier, setChosenSupplier] = useState(null);
    const [requestPositions, setRequestPositions] = useState(null);

    const onSelectSupplier = (supplier) => {
        setChosenSupplier(supplier);
        PapersGeneratorService.getRfxInvitedSupplierPosition(demandId, supplier.id).then(resp => setRequestPositions(resp));
    }

    const onBack = () => {
        setChosenSupplier(null);
        setRequestPositions(null);
    }

    useEffect(() => {
        PapersGeneratorService.getRfxInvitedSupplierWithOffer(demandId).then(resp => setInvitedSuppliers(resp));
    }, [demandId])

    return (<>
        {!chosenSupplier ?
            <PapersGeneratorSelectPopup shareSystem={shareSystem} onClose={onClose} paperId={paper.paperId} title={Tr('choose_supplier')}
                                        list={invitedSuppliers} onSelect={onSelectSupplier}/>
            : <PapersGeneratorSelectPopup shareSystem={shareSystem} onClose={onClose} paperId={paper.paperId} title={Tr('choose_position')}
                                          list={requestPositions} onBack={onBack}/>
        }
    </>)
}
PapersGeneratorRfxInvitedSupplierPosition.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func.isRequired,
    paper: PropTypes.object.isRequired
}
export default PapersGeneratorRfxInvitedSupplierPosition;